import { deserialize, serialize } from 'serializr'
import { autorun, makeAutoObservable } from 'mobx'
import { Cart } from './cart'
import { createModelSchemas } from './serializrModels'

let isFromStorage = false

export class RootStore {
  static instance = null

  static getInstance () {
    if (this.instance != null) {
      return this.instance
    }
    this.instance = new RootStore()
    return this.instance
  }

  _cart = null
  /** @return Cart */
  get cart () {
    if (this._cart !== null) {
      return this._cart
    }

    return this.createCartInstance()
  }

  createCartInstance () {
    const storedJson = localStorage.getItem('Cart')
    if (storedJson) {
      // @ts-ignore
      this._cart = deserialize(Cart, JSON.parse(storedJson))
    } else {
      this._cart = new Cart()
    }

    return this._cart
  }

  clearCart () {
    this._cart = new Cart()
  }

  constructor () {
    makeAutoObservable(this)
    window.addEventListener('storage', () => {
      isFromStorage = true
      this.createCartInstance()
      isFromStorage = false
    })
    autorun(() => {
      if (isFromStorage) {
        return
      }
      // @ts-ignore
      const value = serialize(Cart, this.cart)
      localStorage.setItem('Cart', JSON.stringify(value))
    })
  }

}
createModelSchemas()
